import styled from 'styled-components';
// import TopList from './components/TopList';
import { Row, List, Grid } from 'antd';
import { useGetLifeDoc } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { useEffect } from 'react';
import { isLocaleEnglish } from 'utils';
import { useTranslation } from 'react-i18next';
import GreetingSection from '../../components/navbar/GreetingSection';
import PdfFileIcon from 'assets/images/PDFfileicon.svg';
import downfile from 'assets/images/MakeClaim/downfile.svg';
const SupportPageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;
function UserGuide() {
  const { t, i18n } = useTranslation();
  const { token } = useKeycloakReady();
  const { useBreakpoint } = Grid;
  const { xl } = useBreakpoint();
  const {
    shouldFetch: GetLifeDocFetch,
    data: GetLifeDocFetchData,
    isLoading: GetLifeDocFetchDataisLoading,
  } = useGetLifeDoc('useGetLifeDoc', token || '');
  useEffect(() => {
    GetLifeDocFetch(true);
  }, [GetLifeDocFetch]);
  return (
    <SupportPageContainer
      style={{
        position: 'relative',
      }}
    >
      <GreetingSection pageName={t('life.guide.tittle')} showicon={true} />
      <Row
        justify="center"
        gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
        className="EnquiryContent"
        style={{ marginTop: '40px', marginBottom: '203px' }}
      >
        <List
          style={{ background: '#fff', width: '680px', height: '387' }}
          size="large"
          className={`List ${!xl ? 'to-center' : ''}`}
          header={
            <div>
              <span className="headertittle">{t('life.guide.guideTitle')}</span>
              <div
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  color: '#6f7072',
                  marginTop: '10px',
                }}
              >
                {t('life.guide.linksMsg')}
              </div>
            </div>
          }
          bordered
          loading={GetLifeDocFetchDataisLoading}
          dataSource={GetLifeDocFetchData?.userGuideWeb}
          renderItem={(item) => (
            <List.Item style={{ display: 'flex', flexWrap: 'nowrap' }}>
              <a
                href={isLocaleEnglish(i18n.language) ? item.docUrlEn || '' : item.docUrlTc || ''}
                target="_blank"
                rel="noreferrer"
              >
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                  <img src={PdfFileIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                  <span style={{ fontFamily: 'Roboto400', fontSize: '20px', color: '#20252B' }}>
                    {isLocaleEnglish(i18n.language) ? item.docDescEn || '' : item.docDescTc || ''}
                  </span>
                </div>
              </a>
              <a
                href={isLocaleEnglish(i18n.language) ? item.docUrlEn || '' : item.docUrlTc || ''}
                target="_blank"
                rel="noreferrer"
              >
                <img src={downfile} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
              </a>
            </List.Item>
          )}
        />
      </Row>
    </SupportPageContainer>
  );
}

export default UserGuide;
